import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initSentry } from './lib/sentry.js';

// Fonts (subset to weights used by the design system)
import '@fontsource/ubuntu/300.css';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/500.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/fraunces/700.css';
import '@fontsource/fraunces/400-italic.css';
import '@fontsource/fraunces/500-italic.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import './styles/global.css';

initSentry();

const root = createRoot(document.getElementById('root'));
root.render(
    <App />
);
